<template>
  <!-- inline variant of input -->
  <component :is="cpn" :disabled="disabled" v-if="config.is_inline" v-bind="cfg" v-model="value"></component>
  <v-col v-show="!is_hide_all" v-else v-bind="size" :cols="12">
    <div class="d-flex flex-row">
      <component :is="cpn" :disabled="disabled" v-bind="cfg" v-model="value"></component>
      <div v-if="after" class="py-4 text-no-wrap">{{ after }}</div>
    </div>
  </v-col>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import {
  VCol,
  VInput,
  VSelect,
  VTextField,
  VTextarea,
  VLayout,
  VFlex
} from "vuetify/lib";
import CheckboxGroup from "./input/CheckboxGroup";
import CheckboxSingle from "./input/CheckboxSingle";
import RangeSlider from "./input/RangeSlider";
import RadioGroup from "./input/RadioGroup";
import DatePicker from "./input/DatePicker";
import Location from "./input/Location";
import Uploader from "./input/Uploader";
import StaticText from "./input/StaticText";
import HiddenInput from "./input/HiddenInput";
import List from "./input/List";

// import SingleSelect from './input/SingleSelect';
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  props: ["config"],

  components: {
    VCol,
    VSelect,
    VTextField,
    VTextarea,
    VLayout,
    VFlex,
    VInput,
    RangeSlider,
    CheckboxGroup,
    RadioGroup,
    DatePicker,
    Location,
    Uploader,
    StaticText,
    HiddenInput,
    list: List,
    CheckboxSingle
  },

  watch: {
    config: {
      handler: function(new_conf, old_value) {
        // ...
      },
      deep: true
    }
  },

  data: () => ({
    buffer: null,
    after: null
  }),

  computed: {
    ...mapGetters({
      hasError: "errors/has",
      getError: "errors/get"
    }),

    error: function() {
      if (this.hasError(this.id)) {
        return this.getError(this.id);
      }
      return null;
    },

    id: function() {
      return _.get(this.$props, "config.id", null);
    },

    type: function() {
      return _.get(this.$props, "config.type", "string");
    },

    name: function() {
      return this.id.replace(/\./i, "_");
    },

    title: function() {
      // @todo
      // return this.trans('attr.'+this.id);
      return _.get(this.$props, "config.title", this.id);
    },

    presentation: function() {
      return _.get(this.$props, "config.presentation", "text");
    },

    enabled: function() {
      return _.get(this.$props, "config.enabled", false);
    },

    disabled: function() {
      return !this.enabled;
    },

    has_dependencies: function() {
      return _.get(this.$props, "config.update", false);
    },

    options: function() {
      return _.get(this.$props, "config.options", false);
    },

    defaults: function() {
      return _.get(this.$props, "config.default", null);
    },

    /*value: {
				get: function () { 
					let default_value 	= _.get(this.$props.config, 'default', null);
					let current_value 	= _.get(this.$props.config, 'value', default_value);
					current_value 		= current_value != null ? current_value : default_value; 
					let buffer 			= this.buffer === null ? current_value : this.buffer;
					
					if (buffer == null || buffer === '' || buffer === '*') return null;

					console.log(JSON.stringify({id: this.id, default_value, current_value, buffer}, null, 2));

					return buffer;
				},
				set: function(value) {
					if(value !== null && value !== '' && value !== '*') {
						this.buffer = value;
					} else {
						this.buffer = null; 
					}
					
				}
			},*/

    value: {
      get: function() {
        let default_value = _.get(this.$props.config, "default", null);
        let current_value = _.get(this.$props.config, "value", default_value);
        current_value = current_value != null ? current_value : default_value;

        if (
          current_value == null ||
          current_value === "" ||
          current_value === "*"
        )
          return null;
        // console.log(JSON.stringify({id: this.id, default_value, current_value}, null, 2));

        // Type casting
        switch (this.type) {
          case "integer":
          case "int":
            current_value = _.toInteger(current_value);
            break;
          case "float":
          case "double":
          case "decimal":
            current_value = _.toNumber(current_value);
            break;
          default:
            // current_value = _.toNumber(current_value);
            break;
        }

        return current_value;
      },
      set: function(value) {
        let output = {};
        if (value == null && value == "" && value == "*") {
          _.set(output, this.id, null);
        } else {
          _.set(output, this.id, value);
        }

        // filter to show user-readeble data
        if (!output[this.id] || output[this.id].length == 0) {
          this.$emit("filterTextRemove", this.id);
        }
        if (this.options && !!output[this.id]) {
          const option = this.options.find(opt => opt.value == value);
          let val = null;
          if (this.type == "array") {
            let res = [];
            output[this.id].forEach(item => {
              let opt = this.options.find(opt => opt.value == item);
              if (opt) res.push(opt.text);
            });
            val = res.join(", ");
          } else if (option) {
            val = option.text;
          }
          if (val) {
            const filter = {
              id: this.id,
              title: this.title,
              value: val
            };
            this.$emit("filterTextUpdate", filter);
          }
        }

        this.$emit("input", output);

        if (this.has_dependencies) {
          this.$emit("updateNeeded", null);
        }

        // Update error messages
        this.unsetError(this.id);

        // console.log(JSON.stringify(output, null, 2));
      }
    },

    size: function() {
      return _.get(this.$props, "config.size", { cols: 12, sm: 6, lg: 12 });
    },

    is_hide_all: function() {
      let uses_component = _.has(this.$props, "config.view");
      if (uses_component) return false;
      if (this.presentation == "hidden") return true;
      return false;
    },

    // Switch to neccassary component.
    cpn: function() {
      let override_component = _.get(this.$props, "config.view");
      if (override_component) return override_component;

      // !ACHTUNG
      // for some reasons on radio group null mutates to 0
      // waiting for next version of vuetify
      if (this.id == "room_size") return "v-select";

      if (this.presentation == "select" && this.config.is_list) return "list";
      if (this.presentation == "nullable") {
        return "v-select";
      } else if (this.presentation == "select") {
        return "v-select";
      } else if (this.presentation == "checkbox" && this.type != "boolean") {
        return "checkbox-group";
      } else if (this.presentation == "checkbox" && this.type == "boolean") {
        return "checkbox-single";
      } else if (this.presentation == "radio") {
        return "radio-group";
      } else if (this.presentation == "range") {
        return "range-slider";
      } else if (this.presentation == "date") {
        return "date-picker";
      } else if (this.presentation == "location") {
        return "location";
      } else if (this.presentation == "text") {
        return "v-text-field";
      } else if (this.presentation == "textarea") {
        return "v-textarea";
      } else if (this.presentation == "images") {
        return "uploader";
      } else if (this.presentation == "hidden") {
        return "hidden-input";
      } else if (this.presentation == "legend") {
        return "static-text";
      } else {
        return "v-text-field";
      }
    },

    cfg: function() {
      var cfg = {};

      if (this.presentation == "nullable") {
        cfg = {
          items: [
            { value: null, text: "Any" },
            { value: true, text: "Yes" },
            { value: false, text: "No" }
          ],
          label: this.title,
          value: this.value
        };
      } else if (this.presentation == "select") {
        cfg = {
          label: this.title,
          items: this.options,
          itemText: "text",
          itemValue: "value",
          value: this.value
        };
      } else if (this.presentation == "checkbox") {
        cfg = {
          label: this.title,
          items: this.options,
          multiple: true,
          value: this.value,
          id: this.id
        };
      } else if (this.presentation == "radio") {
        cfg = {
          label: this.title,
          items: this.options || [
            { text: "Yes", value: true },
            { text: "No", value: false }
          ],
          itemText: "text",
          itemValue: "value",
          value: this.value
        };
      } else if (this.presentation == "range") {
        let range = [];
        let min = this.defaults.min;
        let max = this.defaults.max;
        /* for (var i = 0; i < 11; i++) {
						range[i] = this.interpolate(i, 0, 10, min, max)
					} */
        cfg = {
          // items: [range,range],
          label: this.title,
          //
          step: 50,
          thumbLabel: "always",
          tickSize: 3,
          value: [min, max],
          min: min,
          max: max
        };
        // ++
        this.sizes = { xs12: true, sm6: true, md6: true, lg6: true };
      } else if (this.presentation == "date") {
        cfg = {
          label: this.title,
          value: this.value,
          is_btn: this.config.is_btn
        };
      } else if (this.presentation == "location") {
        cfg = {
          label: this.title,
          value: this.value,
          is_btn: this.config.is_btn
        };
      } else if (this.presentation == "number") {
        cfg = {
          type: "number",
          label: this.title,
          value: this.value,
          inputmode: "numeric"
        };
      } else if (this.presentation == "text") {
        cfg = {
          type: "text",
          label: this.title,
          value: this.value
        };
      } else if (this.presentation == "textarea") {
        cfg = {
          type: "text",
          label: this.title,
          value: this.value,
          rows: 3,
          rowHeight: 25,
          autoGrow: true
        };
      } else if (this.presentation == "images") {
        cfg = {
          label: this.title,
          value: this.value
        };
      } else if (this.presentation == "hidden") {
        cfg = {
          label: this.title,
          value: this.value
        };
      } else {
        cfg = {
          label: this.title,
          value: null
        };
      }

      // Append to all type of fields
      if (this.presentation != "textarea") {
        cfg.height = "28px";
      }

      cfg.hideDetails = !this.hasError(this.id);
      cfg.outlined = true;
      cfg.error = this.hasError(this.id);
      cfg.errorMessages = this.error;

      if (_.has(this.$props, "config.suffix")) {
        cfg.suffix = _.get(this.$props, "config.suffix");
      }

      if (_.has(this.$props, "config.after")) {
        this.after = _.get(this.$props, "config.after", null);
      }

      if (_.has(this.$props, "config.mask")) {
        cfg.mask = _.get(this.$props, "config.mask");
      }

      if (this.type == "int" || this.type == "integer") {
        cfg.value = cfg.value == null ? null : _.toNumber(cfg.value);
      }

      if (this.type == "date") {
        if (cfg.value) {
          cfg.value = moment(cfg.value).format("YYYY-MM-DD");
        }
      }

      if (this.type == "boolean" || this.type == "bool") {
        if (
          cfg.value === "true" ||
          cfg.value === "yes" ||
          cfg.value === "on" ||
          cfg.value === "1" ||
          cfg.value === 1
        ) {
          cfg.value = true;
        } else if (
          cfg.value == "false" ||
          cfg.value === "no" ||
          cfg.value === "off" ||
          cfg.value === "0" ||
          cfg.value === 0
        ) {
          cfg.value = false;
        } else {
          cfg.value = !!cfg.value;
        }
      }

      return cfg;
    }
  },

  mounted: function() {
    this.$emit("init", {
      key: this.id,
      value: this.value
    });
  },

  methods: {
    ...mapActions("errors", {
      unsetError: "unset"
    })

    /*
			onInput: function(value) {

				// Sanitize numeric input
				if (this.presentation == 'number') {
					// value = value.replace(/[^0-9\.]/g, '');
					// console.log(value);
				}

				// Refresh value in the buffer				
				this.value = value;
				
				// Update error messages
            	this.unsetError(this.id);

				// Fire event to parent componet
				let output = {};
				_.set(output, this.id, this.value);

				// console.log(JSON.stringify(output, null, 2));

				this.$emit('input', output);

				this.$forceUpdate();
				
				// Refresh the schema if current field has dependent fields
				if (this.has_dependencies) {
					this.$emit('updateNeeded', null);
				}

			},


			interpolate: function(x, x0, x1, y0, y1) {
				let d = (x - x0) / (x1 - x0) 
				return y0 * (1 - d) + y1 * d 
			}
			*/
  }
};
</script>